import { useState, useEffect } from 'react';

export function useClipboardPermission() {
  const [canCopy, setCanCopy] = useState(false);

  useEffect(() => {
    // Check if running in a browser environment
    if (typeof navigator !== 'undefined') {
      // Consider clipboard available if the API exists
      setCanCopy(!!navigator.clipboard);
    }
  }, []);

  return canCopy;
}
